export const initBlockSearch = (editor) => {
    const blockManager = editor.BlockManager;
    const pfx = editor.getConfig('stylePrefix') || 'gjs-';

    const filterBlocks = (query) => {
        const all = blockManager.getAll();
        const queryLower = (query || '').trim().toLowerCase();

        if (!queryLower) {
            blockManager.render();
        } else {
            const blocksArray = all.models || all.toArray?.() || Array.from(all);
            const filtered = blocksArray.filter((block) => {
                const label = block.get?.('label') || block.get?.('content') || '';
                const category = block.get?.('category') || '';
                const searchable = `${label} ${category}`.toLowerCase();
                return searchable.indexOf(queryLower) > -1;
            });
            blockManager.render(filtered);
        }
        injectSearch();
        requestAnimationFrame(() => searchInput.focus());
    };

    const searchContainer = document.createElement('div');
    searchContainer.className = `${pfx}blocks-search-container`;
    searchContainer.style.cssText = `
        padding: 10px;
        border-bottom: 1px solid rgba(0,0,0,0.25);
        background-color: var(--gjs-primary-color, rgba(0,0,0,0.1));
        position: sticky;
        top: 0;
        z-index: 1;
    `;

    const searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.placeholder = 'Blöcke durchsuchen...';
    searchInput.className = `${pfx}blocks-search-input`;
    searchInput.style.cssText = `
        width: 100%;
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid var(--gjs-border-color, rgba(255,255,255,0.2));
        background-color: transparent;
        color: var(--gjs-font-color, #9ca3af);
        font-size: 13px;
        box-sizing: border-box;
    `;
    searchInput.setAttribute('aria-label', 'Search blocks');

    searchInput.addEventListener('input', (e) => filterBlocks(e.target.value));
    searchInput.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
            searchInput.value = '';
            filterBlocks('');
            searchInput.blur();
        }
    });

    searchContainer.appendChild(searchInput);

    const injectSearch = () => {
        const blockCategories = document.querySelector(`.${pfx}block-categories`);
        const target = blockCategories?.parentElement;
        if (target && !target.contains(searchContainer)) {
            target.insertBefore(searchContainer, blockCategories);
        }
    };

    editor.on('command:run:open-blocks', injectSearch);

    editor.on('load', () => {
        setTimeout(injectSearch, 200);
    });
};
